import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function DatenschutzPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-[#59d0d4]/30 selection:text-[#3b7780] flex flex-col" data-id="element-507">
      <Navbar data-id="element-508" />
      <main className="flex-grow pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto w-full" data-id="element-509">
        <h1 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-10 tracking-tight" data-id="element-510">
          Datenschutzerklärung
        </h1>

        <div className="prose prose-slate max-w-none space-y-8 text-slate-600 leading-relaxed" data-id="element-511">
          <section data-id="element-512">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-513">
              1. Datenschutz auf einen Blick
            </h2>
            <h3 className="text-xl font-bold text-slate-800 mb-2 mt-6" data-id="element-514">
              Allgemeine Hinweise
            </h3>
            <p data-id="element-515">
              Die folgenden Hinweise geben einen einfachen Überblick darüber,
              was mit Ihren personenbezogenen Daten passiert, wenn Sie diese
              Website besuchen. Personenbezogene Daten sind alle Daten, mit
              denen Sie persönlich identifiziert werden können.
            </p>
          </section>

          <section data-id="element-516">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-517">
              2. Hosting und Content Delivery Networks (CDN)
            </h2>
            <p data-id="element-518">
              Wir hosten die Inhalte unserer Website bei externen Anbietern. Die
              personenbezogenen Daten, die auf dieser Website erfasst werden,
              werden auf den Servern der Hoster gespeichert.
            </p>
          </section>

          <section data-id="element-519">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-520">
              3. Allgemeine Hinweise und Pflichtinformationen
            </h2>
            <h3 className="text-xl font-bold text-slate-800 mb-2 mt-6" data-id="element-521">
              Datenschutz
            </h3>
            <p data-id="element-522">
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
              Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
              vertraulich und entsprechend der gesetzlichen
              Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>

            <h3 className="text-xl font-bold text-slate-800 mb-2 mt-6" data-id="element-523">
              Verantwortliche Stelle
            </h3>
            <p data-id="element-524">
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser
              Website ist:
            </p>
            <p className="mt-2 bg-slate-50 p-4 rounded-lg border border-slate-100" data-id="element-525">
              2N Kurse GbR Dres. Schwenk, Striegel, Herzog
              <br data-id="element-526" />
              Ludwigsplatz 1a
              <br data-id="element-527" />
              90403 Nürnberg
              <br data-id="element-528" />
              Telefon: 0911 – 56836360
              <br data-id="element-529" />
              E-Mail: info@2n-fortbildung.de
            </p>
          </section>

          <section data-id="element-530">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-531">
              4. Datenerfassung auf dieser Website
            </h2>
            <h3 className="text-xl font-bold text-slate-800 mb-2 mt-6" data-id="element-532">
              Cookies
            </h3>
            <p data-id="element-533">
              Unsere Internetseiten verwenden so genannte „Cookies“. Cookies
              sind kleine Textdateien und richten auf Ihrem Endgerät keinen
              Schaden an. Sie werden entweder vorübergehend für die Dauer einer
              Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf
              Ihrem Endgerät gespeichert.
            </p>
            <p className="mt-4" data-id="element-534">
              Wir verwenden ein Consent-Management-Tool, um Ihre Einwilligung
              zur Speicherung bestimmter Cookies einzuholen und
              datenschutzkonform zu dokumentieren. Wenn Sie unsere Website
              betreten, wird ein Cookie in Ihrem Browser gespeichert, in dem die
              von Ihnen erteilten Einwilligungen oder der Widerruf dieser
              Einwilligungen gespeichert werden (2n_cookie_consent).
            </p>
          </section>
        </div>
      </main>
      <Footer data-id="element-535" />
    </div>;
}